import React from "react";
import { StyledEditorialWrapper } from "./styles.js";
const EditorialWrapper = ({ children }) => {
  return <StyledEditorialWrapper data-editorial-wrapper={true}>{children}</StyledEditorialWrapper>;
};

export default EditorialWrapper;
